// src/api/api.js

import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { doLogout } from '../context/AuthContext';

const api = axios.create({
  baseURL: 'https://api.integranube.cl/inadmin',
  headers: { 'Content-Type': 'application/json' },
});

// Antes de cada request comprobamos expiración (excepto login)
api.interceptors.request.use(
  config => {
    if (config.url?.endsWith('/auth/login')) {
      return config;
    }

    const auth = localStorage.getItem('adminAuth');
    if (auth) {
      const { token } = JSON.parse(auth);
      try {
        const { exp } = jwtDecode(token);
        if (Date.now() >= exp * 1000) {
          // JWT expirado: cancelo y dejo que el response interceptor redirija
          doLogout();
          return Promise.reject(new axios.Cancel('JWT expirado'));
        }
        config.headers.Authorization = `Bearer ${token}`;
      } catch {
        doLogout();
        return Promise.reject(new axios.Cancel('JWT inválido'));
      }
    }
    return config;
  },
  error => Promise.reject(error)
);

// Si recibimos 401, hacemos logout una única vez
api.interceptors.response.use(
  res => res,
  error => {
    if (error.response?.status === 401) {
      doLogout();
    }
    return Promise.reject(error);
  }
);

export default api;
